import api from '@/api';
import { UpdateGroupRequest } from '@/types/api/group/request';
import { ApiError } from '@/utils/shared/api.error';
import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';

type TData = void;
type TError = ApiError;
type TVariables = UpdateGroupRequest;
type TContext = {};

export function useUpdateGroupMutation(options?: UseMutationOptions<TData, TError, TVariables, TContext>) {
  const queryClient = useQueryClient();

  return useMutation<TData, TError, TVariables, TContext>({
    mutationKey: ['update-group'],
    mutationFn: (data: UpdateGroupRequest) => api.group.update(data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['groups'] }),
    ...options,
  });
}
